import { render, staticRenderFns } from "./TheRedirect.vue?vue&type=template&id=7f72fb08&scoped=true"
import script from "./TheRedirect.vue?vue&type=script&lang=js"
export * from "./TheRedirect.vue?vue&type=script&lang=js"
import style0 from "./TheRedirect.vue?vue&type=style&index=0&id=7f72fb08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f72fb08",
  null
  
)

export default component.exports